<template>
  <v-dialog v-model="dialog" persistent max-width="960" scrollable>
    <template #activator="{ props }">
      <v-btn :small="$vuetify.display.xs" color="info" dark v-bind="props">
        FAQ
        <v-icon :small="$vuetify.display.xs" class="ml-2">
          {{ mdiHelp }}
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="d-block">
        <v-toolbar-title style="white-space: normal"> Welcome to WhaleTrader! </v-toolbar-title>
      </v-card-title>
      <v-card-title class="d-block py-0 mb-4 font-italic">
        Please report any errors or other feedback to
        <a href="mailto:contact@whalewisdom.com">contact@whalewisdom.com</a>
      </v-card-title>

      <v-tabs v-model="tabs" class="pl-4">
        <v-tab key="1" href="#tab-1"> Introduction </v-tab>
        <v-tab key="2" href="#tab-2"> FAQ </v-tab>
      </v-tabs>

      <v-divider />

      <v-card-text style="height: 600px">
        <v-window v-model="tabs" touchless>
          <v-window-item key="1" value="tab-1">
            <!-- <helpers-section-header class="mt-4">Welcome to the Insider Backtester!</helpers-section-header> -->
            <helpers-section-sub-header class="my-2">
              What is backtesting?
            </helpers-section-sub-header>
            <p>
              Backtesting is the use of historical data to construct a trading strategy and
              determine if it would have been profitable in the past. By analyzing how a
              hypothetical strategy would have performed historically, an investor can devise a
              trading process with the best chance of success going forward.
            </p>
            <p>
              WhaleWisdom.com does not represent or warrant that the data produced by the Whale
              Backtester is accurate, complete, reliable or error free. Results are theoretical and
              will likely differ with real-world results.
            </p>
            <p>We do not provide any guarantees for uptime or availability of WhaleTrader.</p>
          </v-window-item>
          <v-window-item key="2" value="tab-2">
            <helpers-section-sub-header class="my-2"> FAQ </helpers-section-sub-header>
            <dl>
              <dt>How far back in time can I backtest?</dt>
              <dd>
                With most signals you can backtest as far back as January 3rd, 2006. Certain
                trending metrics are not available until 2008.
              </dd>

              <dt>How soon can I backtest using yesterdays stock prices?</dt>
              <dd>
                We make no guarantees on when prices are available for backtesting. Ideally prices
                and computed metrics needed are available by 5am EST, but can be delayed as we rely
                on multiple data vendors and our own internal processes.
              </dd>
              <dt>Does this replace the 13F Backtester?</dt>
              <dd>
                Not necessarily. The 13F Backtester is designed to re-evaluate holdings once per
                quarter and to exactly clone the fund(s) portfolio. WhaleTrader will evaluate
                holdings daily and will not exactly
              </dd>
              <dt>Does this replace the Insider Backtester?</dt>
              <dd>
                Yes. WhaleTrader offers everything from the Insider Backtester and a whole lot more.
              </dd>
            </dl>
          </v-window-item>
        </v-window>
      </v-card-text>

      <v-divider />

      <v-card-actions class="px-4 py-2">
        <v-spacer />
        <v-checkbox
          v-model="dontShowAgain"
          :ripple="false"
          :true-value="1"
          :false-value="0"
          label="Don't show this on page load"
          hide-details
          class="d-inline-flex shrink ma-0 pa-0"
        />
        <v-btn color="primary" class="ml-6" @click="dialog = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiHelp } from '@mdi/js'

export default {
  data() {
    return {
      mdiHelp,
      dialog: false,
      tabs: null,
      dontShowAgain: 0
    }
  },

  watch: {
    dontShowAgain(val) {
      this.$cookies.set('whale_backtester_help_dialog', val)
    }
  },

  created() {
    const cookie = this.$cookies.get('whale_backtester_help_dialog')

    if (!cookie) {
      // 1 year from now
      const expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))

      // If we haven't created a cookie yet,
      // have the 'Don't show this on page load' checkbox be unchecked
      this.$cookies.set('insider_backtester_help_dialog', 0, { expires: expiryDate })
    } else {
      this.dontShowAgain = parseInt(cookie)
      this.dialog = Boolean(!this.dontShowAgain)
    }
  }
}
</script>
